// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { KpiDashboardAreaId } from './KpiDashboardAreaId'
import {
  KpiDashboardAreaNavigation,
  KpiDashboardAreaNavigationIcon,
} from './KpiDashboardAreaNavigation'
import { KpiDashboardAreaRoutes } from './KpiDashboardAreaRoutes'

const LazyKpiDashboardComponent = lazy(() => import('./KpiDashboardArea'))

const KpiDashboardComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyKpiDashboardComponent />
  </SuspenseLoadingWrapper>
)

export const KpiDashboardArea = {
  id: KpiDashboardAreaId,
  requiredRight: BoumRight.AREA_DASHBOARD,
  Icon: KpiDashboardAreaNavigationIcon,
  NavigationComponent: KpiDashboardAreaNavigation,
  route: {
    path: KpiDashboardAreaRoutes.route,
    component: KpiDashboardComponent,
  },
}
